/**
 * Mock Time Tracking Data for Development/Demo
 * Use this when backend is not available
 */

import { TimeLog, ActiveTimer, TimeSummary, TimeReport } from '../model/types';

export const mockTimeLogs: TimeLog[] = [
  {
    id: 'log-1',
    taskId: 'task-1',
    userId: 'user-1',
    userName: 'John Smith',
    taskName: 'Implement JWT authentication',
    hours: 2,
    minutes: 30,
    totalMinutes: 150,
    notes: 'Set up JWT token generation and validation',
    date: '2025-01-24T00:00:00Z',
    startTime: '2025-01-24T09:00:00Z',
    endTime: '2025-01-24T11:30:00Z',
    isActive: false,
    createdAt: '2025-01-24T09:00:00Z',
    updatedAt: '2025-01-24T11:30:00Z',
  },
  {
    id: 'log-2',
    taskId: 'task-2',
    userId: 'user-1',
    userName: 'John Smith',
    taskName: 'Create user dashboard',
    hours: 1,
    minutes: 45,
    totalMinutes: 105,
    notes: 'Designed and implemented responsive dashboard layout',
    date: '2025-01-24T00:00:00Z',
    startTime: '2025-01-24T13:00:00Z',
    endTime: '2025-01-24T14:45:00Z',
    isActive: false,
    createdAt: '2025-01-24T13:00:00Z',
    updatedAt: '2025-01-24T14:45:00Z',
  },
  {
    id: 'log-3',
    taskId: 'task-3',
    userId: 'user-1',
    userName: 'John Smith',
    taskName: 'Fix login redirect bug',
    hours: 0,
    minutes: 45,
    totalMinutes: 45,
    notes: 'Fixed redirect issue after successful login',
    date: '2025-01-23T00:00:00Z',
    startTime: '2025-01-23T15:00:00Z',
    endTime: '2025-01-23T15:45:00Z',
    isActive: false,
    createdAt: '2025-01-23T15:00:00Z',
    updatedAt: '2025-01-23T15:45:00Z',
  },
  {
    id: 'log-4',
    taskId: 'task-4',
    userId: 'user-1',
    userName: 'John Smith',
    taskName: 'Update API documentation',
    hours: 3,
    minutes: 15,
    totalMinutes: 195,
    notes: 'Documented all REST API endpoints with examples',
    date: '2025-01-23T00:00:00Z',
    startTime: '2025-01-23T09:30:00Z',
    endTime: '2025-01-23T12:45:00Z',
    isActive: false,
    createdAt: '2025-01-23T09:30:00Z',
    updatedAt: '2025-01-23T12:45:00Z',
  },
];

export const mockActiveTimer: ActiveTimer | null = null;

export const mockTimeSummary: TimeSummary = {
  totalHours: 8,
  totalMinutes: 15,
  logCount: 4,
  byTask: [
    {
      taskId: 'task-1',
      taskName: 'Implement JWT authentication',
      totalMinutes: 150,
      logCount: 1,
    },
    {
      taskId: 'task-2',
      taskName: 'Create user dashboard',
      totalMinutes: 105,
      logCount: 1,
    },
    {
      taskId: 'task-3',
      taskName: 'Fix login redirect bug',
      totalMinutes: 45,
      logCount: 1,
    },
    {
      taskId: 'task-4',
      taskName: 'Update API documentation',
      totalMinutes: 195,
      logCount: 1,
    },
  ],
};

export const mockTimeReport: TimeReport = {
  period: 'week',
  startDate: '2025-01-20T00:00:00Z',
  endDate: '2025-01-26T23:59:59Z',
  summary: mockTimeSummary,
  logs: mockTimeLogs,
};

// Mock tasks for selection
export const mockTasks = [
  { id: 'task-1', title: 'Implement JWT authentication', boardId: 'board-1' },
  { id: 'task-2', title: 'Create user dashboard', boardId: 'board-1' },
  { id: 'task-3', title: 'Fix login redirect bug', boardId: 'board-1' },
  { id: 'task-4', title: 'Update API documentation', boardId: 'board-1' },
  { id: 'task-5', title: 'Implement drag and drop for kanban', boardId: 'board-1' },
  { id: 'task-6', title: 'Add sprint burndown chart', boardId: 'board-1' },
  { id: 'task-7', title: 'Create time tracking feature', boardId: 'board-1' },
  { id: 'task-8', title: 'Setup CI/CD pipeline', boardId: 'board-1' },
];

export const getMockTimeLog = (logId: string): TimeLog | undefined => {
  return mockTimeLogs.find(log => log.id === logId);
};

export const getMockTaskTimeLogs = (taskId: string): TimeLog[] => {
  return mockTimeLogs.filter(log => log.taskId === taskId);
};

export const getMockUserTimeLogs = (userId: string): TimeLog[] => {
  return mockTimeLogs.filter(log => log.userId === userId);
};
